<template>
  <div class="c-black bg-gray20">
    <div
        v-for="(service, i) in services"
        :key="service.id"
        :class="{ SELECTED: i === selected }"
        :selenium="`search-results-item:${i + 1}`"
        class="ITEM x-orange-emphasis"
        @click="$emit('select', i)"
        v-html="service.name_highlighted || service.name"/>
  </div>
</template>

<script>
export default {
  name: 'search-results',
  props: {
    services: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Number,
      required: true,
      default: -1,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.ITEM {
  @include padding(2);
  cursor: pointer;

  &:hover,
  &:focus,
  &.selected {
    background-color: black;
    color: white;
  }
}
</style>
